import React from 'react';
import { ColorSwatches } from '@honda-canada/design-system-react';
import { EqualHeightElement } from '../../../utils/components/EqualHeight';
import TrimCardHighlight from './TrimCardHighlight';
import themeStyles from './styles/AdditionalFeatures.styles';
const ExteriorColorSwatches = themeStyles.apply(ColorSwatches, 'ExteriorColorSwatches');
const AdditionalFeatures = ({ trim, nameBadge, transmissionName, colors, dealerName }) => (React.createElement(React.Fragment, null,
    React.createElement(ExteriorColorSwatches, { colors: colors }),
    React.createElement(EqualHeightElement, { name: "TrimKeyFeatures", placeholder: !trim.compareTrimKeyFeatures },
        React.createElement(TrimCardHighlight, { trim: trim, nameBadge: nameBadge, transmissionName: transmissionName, dealerName: dealerName }))));
export default AdditionalFeatures;
